import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { UnidEntitySearchComponent } from './unid-entity-search-component';

export function UnidEntitySearchFactory() {
    return (
        <BaseLayoutFactory>
            <UnidEntitySearchComponent />
        </BaseLayoutFactory>
    );
}
